//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Action } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import Block from '@internal-reviews/components/Block'
import { ROUTES } from '@router'

import translations from './Reviews.translations'

export default {
  name: 'Reviews',
  components: {
    Action,
    Block,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    reviews: { type: Array, required: true },
    rate: { type: Object, required: true },
    summary: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
    }),
    reviewPage() {
      const { FF_NEW_URL_FORMAT } = this.$config
      const useNewUrl = FF_NEW_URL_FORMAT.includes(this.country)

      let params = {}

      let landingSlug = ''

      if (useNewUrl) {
        landingSlug = this.$route.params.slugV2
        params = {
          landingSlug,

          landingId: this.$route.params.uuid,
        }
      } else {
        landingSlug = this.$route.params.category
        params = {
          landingSlug: landingSlug.replace('.html', ''),
        }
      }

      const name = ROUTES.REVIEWS.PAGES.LANDING

      return {
        type: 'internal',
        name,
        params,
      }
    },
    translations() {
      return translations
    },
  },
}
